export const enum PropertyCtaInteractionEvent {
  /**
   * User clicked on book a viewing button
   */
  bookAViewingButtonClick = 'bookAViewingButtonClick',

  /**
   * Click on property page call CTA button
   */
  propertyPageCallClick = 'propertyPageCallClick',
}
